/**
 * Translate description: Input serch with ajax
 */

import { useRef, useState, useEffect } from 'react';


import Autocomplete from '@mui/joy/Autocomplete';
import CircularProgress from '@mui/joy/CircularProgress';

import { useLanguageContext } from "../context/LanguageContext";

import axios from 'axios';

export function InputSearchAjax(props = {}) {
  const timerRef = useRef();
  const { t } = useLanguageContext();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');

  const { field = 'name', exclude, debouncetimeout, minLength, url, method, lang_id, bodyparams, remap, ...rest } = props;

  useEffect(() => {
    loadResults(1, lang_id, method, bodyparams);
  }, [search, lang_id, method, bodyparams]);

  const loadResults = (page = 1, lang, type = 'post', bodyparams = null) => {
    if (loading || search.length < (minLength ?? 2)) return setItems([]);
    setLoading(true);

    let filter = { [field]: { value: search, operator: 'like' } };
    if (lang) filter.lang = { id: lang_id, operator: '=' };
    if (bodyparams) filter = { ...filter, ...bodyparams }

    axios.post(`${process.env.REACT_APP_TMBACK_URL}/api${url}`, { filter }, { withCredentials: true })
      .then(
        (res) => {
          if (exclude && Array.isArray(exclude) && exclude.length > 0) {
            res.data.data = res.data.data.filter(item => !exclude.includes(item.id));
          }

          if (typeof remap === 'function') res.data.data = remap(res.data.data);
          setItems(res.data.data);
          setLoading(false);
        },
        (error) => {
          setError(error);
          setLoading(false);
        }
      );
  }

  const debouncedSearch = (inputValue) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setSearch(inputValue);
    }, debouncetimeout ?? 500);
  };

  /*
    const filterOptions = (options, { inputValue }) => {
      debouncedSearch(inputValue);
      return items;
    };
    */

  const filterOptions = (options, { inputValue, getOptionSelected }) => {
    const filteredOptions = options.filter(option => {
      if (exclude && Array.isArray(exclude)) {
        return !exclude.includes(option.id);
      }
      return true;
    });

    debouncedSearch(inputValue);
    return filteredOptions;
  };

  // Don't remove this
  const label_0 = t('Select a value or start typing for search');
  const label_1 = t('Type min 1 characters');
  const label_2 = t('Type min 2 characters');
  const label_3 = t('Type min 3 characters');

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) => option.title || option.login || option.name || option.domain || option.toString() || ''}
      placeholder={minLength > 0 ? t(`Type min ${minLength} characters`) : label_0}
      endDecorator={
        loading ? (
          <CircularProgress size="sm" sx={{ bgcolor: 'background.surface' }} />
        ) : null
      }
      filterOptions={filterOptions}
      readOnly={loading}
    />
  );
}

